import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api, fileUrl } from "@/lib/api";
import { ArrowLeft, MapPin, Calendar } from "lucide-react";
import BeforeAfter from "@/components/BeforeAfter";

export default function ProjectDetail() {
    const { slug } = useParams();
    const [p, setP] = useState(null);
    const [err, setErr] = useState(false);

    useEffect(() => {
        api.get(`/projects/${slug}`).then((r) => setP(r.data)).catch(() => setErr(true));
    }, [slug]);

    if (err) return <div className="py-32 text-center text-stone-500">Projeto não encontrado. <Link to="/trabalhos" className="text-amber-700 underline">Voltar</Link></div>;
    if (!p) return <div className="py-32 text-center text-stone-400">A carregar…</div>;

    return (
        <article className="pb-20">
            <div className="bg-stone-950 text-white py-16">
                <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
                    <Link to="/trabalhos" className="inline-flex items-center gap-2 text-stone-400 hover:text-amber-500 text-sm mb-6"><ArrowLeft className="w-4 h-4" /> Voltar aos trabalhos</Link>
                    <div className="text-xs font-mono uppercase tracking-wider text-amber-500 mb-3">{p.category}</div>
                    <h1 className="font-display text-3xl sm:text-5xl font-bold mb-4">{p.title}</h1>
                    <div className="flex flex-wrap gap-4 text-sm text-stone-300">
                        <span className="inline-flex items-center gap-1"><MapPin className="w-4 h-4" /> {p.location}</span>
                        {p.date && <span className="inline-flex items-center gap-1"><Calendar className="w-4 h-4" /> {p.date}</span>}
                    </div>
                </div>
            </div>

            <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 pt-12">
                {p.cover_file_id && (
                    <img src={fileUrl(p.cover_file_id)} alt={p.title} className="w-full aspect-[16/9] object-cover rounded-xl mb-10" />
                )}
                <div className="grid md:grid-cols-2 gap-10 mb-10">
                    {p.problem && <div><h3 className="font-display font-semibold text-xl mb-2">Objetivo do cliente</h3><p className="text-stone-600 leading-relaxed">{p.problem}</p></div>}
                    {p.works_done && <div><h3 className="font-display font-semibold text-xl mb-2">Trabalhos realizados</h3><p className="text-stone-600 leading-relaxed">{p.works_done}</p></div>}
                    {p.materials && <div className="md:col-span-2"><h3 className="font-display font-semibold text-xl mb-2">Materiais / soluções</h3><p className="text-stone-600 leading-relaxed">{p.materials}</p></div>}
                </div>

                {(p.before_after || []).map((ba, i) => (
                    <div key={ba.before_id || ba.after_id || `ba-${i}`} className="mb-10">
                        <h3 className="font-display font-semibold text-xl mb-4">Antes / Depois</h3>
                        <BeforeAfter before={fileUrl(ba.before_id)} after={fileUrl(ba.after_id)} alt={p.title} />
                    </div>
                ))}

                {p.gallery_ids?.length > 0 && (
                    <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-10">
                        {p.gallery_ids.map((id) => (
                            <img key={id} src={fileUrl(id)} alt="" className="w-full aspect-square object-cover rounded-lg" />
                        ))}
                    </div>
                )}

                <div className="text-center py-10 bg-[hsl(42,20%,96%)] rounded-xl">
                    <h3 className="font-display text-2xl font-bold text-stone-900 mb-3">Tem um projeto semelhante?</h3>
                    <Link to="/orcamento" className="btn-ochre inline-flex items-center gap-2 px-6 py-3 rounded-full font-semibold">Pedir orçamento</Link>
                </div>
            </div>
        </article>
    );
}
